<ng-container *ngIf="data?.topics?.length && !loading">
    <div class="ai-share-of-voice-container">
        <div class="chart">
            <app-pie-chart 
                [data]="chartData"
                [chartHeight]="320"
                [pieSize]="266"
                [plotOptionsDistance]="-30"
                [colors]="colors" 
                format="percentage"
                [loading]="loading"
                [isCompactMode]="true"
                [includeLegend]="false"
                valueField="share">
            </app-pie-chart>
        </div>
        <div class="table">
            <ag-grid-angular
                class="ai-share-of-voice-grid ag-theme-alpine"
                style="width: 100%;"
                [rowData]="rowData?.brands"
                [columnDefs]="colDefs"
                [modules]="modules"
                [theme]="theme"
                [domLayout]="'autoHeight'"
                [suppressCellFocus]="true"
                [gridOptions]="gridOptions"
                (gridReady)="onGridReady($event)">
            </ag-grid-angular>            
        </div>
    </div>
</ng-container>
<app-no-widget-data *ngIf="!this.data?.topics?.length && !loading"></app-no-widget-data>
<app-loader *ngIf="loading"></app-loader>